module.exports = __webpack_public_path__ + "img/0x2090c8295769791ab7A3CF1CC6e0AA19F35e441A.51b9a398.png";